import React from 'react';
import PropTypes from 'prop-types';
import { Text, Pressable } from 'react-native';
import { Icon as RNVIcon } from 'renative';
import Theme from 'Theme';
import { useFavoriteSettingsContext } from '../../../../../runtime/Page/FavoriteSettings/FavoriteSettingsContext';

import defaultStyles from './NavigationPickerHeader.jss';

const NavigationPickerHeader = ({ isToggled, selectedItemLabel, onToggle, testID }) => {
    const { setNavigationPickerHeaderLayout } = useFavoriteSettingsContext();

    const textLayout = (event) => {
        const iconWidth = 17; // from defaultStyles.icon
        const iconMarginLeft = 10; // from defaultStyles.icon
        const widthAndMarginLeft = iconWidth + iconMarginLeft;

        setNavigationPickerHeaderLayout({
            width: event.nativeEvent.layout.width + widthAndMarginLeft,
            x: event.nativeEvent.layout.x + 80 // x is always off for 80, that's why it's hardcoded
        });
    };
    return (
        <Pressable style={defaultStyles.container} onPress={onToggle} testID={testID}>
            <Text
                numberOfLines={1}
                style={[
                    defaultStyles.label,
                    { color: isToggled ? Theme.lightThemeTextColor : Theme.primaryTextColor }
                ]}
                onLayout={textLayout}
            >
                {selectedItemLabel}
            </Text>
            <RNVIcon
                iconFont="fontAwesome"
                iconName={isToggled ? 'caret-up' : 'caret-down'}
                iconColor={isToggled ? Theme.lightThemeTextColor : Theme.primaryTextColor}
                style={defaultStyles.icon}
                onPress={onToggle}
            />
        </Pressable>
    );
};

NavigationPickerHeader.defaultProps = {
    isToggled: false,
    testID: undefined
};

NavigationPickerHeader.propTypes = {
    isToggled: PropTypes.bool,
    selectedItemLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    onToggle: PropTypes.func.isRequired,
    testID: PropTypes.string
};

export default NavigationPickerHeader;
